import {createEffect, ErrorBoundary, JSXElement} from "solid-js"
import Header from "~/components/Header";
import css from "~/components/layout.module.css"
import ErrorPage from "~/components/error/ErrorPage";
import Footer from "./Footer";
import {useIsRouting} from "@solidjs/router";

export default function Layout(props: { children: JSXElement }): JSXElement {

    let app!: HTMLDivElement;

    const isRouting = useIsRouting();

    createEffect(() => {
        if (isRouting()) {
            app.scrollTop = 0
        }
    })

    return (
        <div ref={app} class={css.app}>
            <Header/>
            <div class={css.content}>
                <ErrorBoundary fallback={(err, reset) => <ErrorPage err={err} reset={reset}/>}>
                    {props.children}
                </ErrorBoundary>
            </div>
            <Footer/>
        </div>
    )
}